import {toAbsoluteUrl} from '_metronic/helpers'
import {Dispatch, FC, SetStateAction, useRef, useState, useEffect} from 'react'
import {PolicyDataType} from '../components/Policies'
import Searchbar from '../components/Searchbar'
import {DocumentDataType} from '../components/Documents'
import Button from '../components/Button'
import DocumentViewerModal from 'app/components/DocumentViewerModal'

type Props = {
  policies: PolicyDataType[]
  documents: DocumentDataType[]
  setRequestedResource: Dispatch<SetStateAction<{id: string}>>
  openRequestAccessModal: () => void
  requestedResourcesIdArr: Array<string>
}

const ResourcesTab: FC<Props> = ({
  policies,
  documents,
  setRequestedResource,
  openRequestAccessModal,
  requestedResourcesIdArr,
}) => {
  const [policiesDocuments, setPoliciesDocuments] = useState([
    {
      id: 'documents',
      name: 'Documents',
      list: [...(documents || [])],
      filteredList: [...(documents || [])] as DocumentDataType[],
    },
    {
      id: 'policies',
      name: 'Policies',
      list: [...(policies || [])],
      filteredList: [...(policies || [])] as PolicyDataType[],
    },
  ])

  const [searchTerm, setSearchTerm] = useState<string>('')
  const [isNoSearchFound, setIsNoSearchFound] = useState(false)
  const [showDocumentViewer, setShowDocumentViewer] = useState(false)
  const [selectedFile, setSelectedFile] = useState<{
    url: string
    name: string
  } | null>(null)

  useEffect(() => {
    if (policies?.length > 0 || documents.length > 0) {
      setPoliciesDocuments([
        {
          id: 'documents',
          name: 'Documents',
          list: [...(documents || [])],
          filteredList: [...(documents || [])] as DocumentDataType[],
        },
        {
          id: 'policies',
          name: 'Policies',
          list: [...(policies || [])],
          filteredList: [...(policies || [])] as PolicyDataType[],
        },
      ])
    }
  }, [policies, documents])

  useEffect(() => {
    const updatedData = policiesDocuments.map((group) => ({
      ...group,
      filteredList: group.list.filter((item) =>
        item.title.toLowerCase().includes(searchTerm.toLowerCase())
      ),
    }))
    setPoliciesDocuments(updatedData)
    setIsNoSearchFound(updatedData.filter((group) => group.filteredList.length > 0).length === 0)
  }, [searchTerm])

  return (
    <div className='w-100 d-flex flex-column flex-lg-row' style={{gap: '32px'}}>
      <div className='w-100 w-lg-25 d-flex flex-column' style={{gap: '12px', flexShrink: '0'}}>
        <div className='d-flex justify-content-between align-items-center'>
          <h3
            className='d-lg-none flex-fill text-custom-primary-gray mb-0'
            style={{fontSize: '20px', fontWeight: '600'}}
          >
            Resources
          </h3>

          <div className='flex-lg-fill'>
            <Searchbar searchTerm={searchTerm} setSearchTerm={setSearchTerm} />
          </div>
        </div>

        {!isNoSearchFound && (
          <div className='d-none d-lg-flex flex-column' style={{gap: '4px'}}>
            {policiesDocuments.map(
              (group, idx) =>
                group.filteredList.length > 0 && (
                  <div
                    key={group.id}
                    className={`cursor-pointer text-custom-primary-gray`}
                    style={{
                      borderRadius: '8px',
                      fontSize: '14px',
                      fontWeight: '300',
                      padding: '6px 8px',
                    }}
                    onClick={() => {
                      const element = document.getElementById(group.id)
                      element?.scrollIntoView({behavior: 'smooth'})
                    }}
                    onMouseEnter={(e: React.MouseEvent<HTMLElement>) => {
                      e.currentTarget.style.backgroundColor = '#F3F4F6'
                    }}
                    onMouseLeave={(e: React.MouseEvent<HTMLElement>) => {
                      e.currentTarget.style.backgroundColor = 'transparent'
                    }}
                  >
                    {group.name}
                  </div>
                )
            )}
          </div>
        )}
      </div>

      <div
        className='flex-fill d-flex flex-column'
        style={{
          gap: '40px',
        }}
      >
        {!isNoSearchFound ? (
          policiesDocuments.map(
            (group, index) =>
              group.filteredList.length > 0 && (
                <div key={group.id} id={group.id} className=''>
                  <h3
                    className='text-custom-primary-gray fw-medium'
                    style={{fontSize: '18px', marginBottom: '24px'}}
                  >
                    {group.name}
                  </h3>

                  <div className='d-flex flex-column' style={{gap: '20px'}}>
                    {group.filteredList.map((item, index) => (
                      <div
                        key={index}
                        className='d-flex justify-content-between align-items-center bg-white'
                        style={{
                          border: '1px solid #E5E7EB',
                          borderRadius: '8px',
                          gap: '16px',
                          padding: '24px',
                        }}
                      >
                        <h4
                          className='text-custom-primary-gray fw-medium mb-0'
                          style={{fontSize: '16px'}}
                        >
                          {item.title}
                        </h4>

                        {requestedResourcesIdArr.includes(item.id) ? (
                          <Button disabled>
                            <img
                              alt='circle-check-icon'
                              src={toAbsoluteUrl('/media/icon/circle-check-gray-900.svg')}
                              className='me-2'
                              style={{height: '18px', width: '18px'}}
                            />
                            <span>Requested</span>
                          </Button>
                        ) : item.access.toLowerCase() === 'public' ? (
                          <Button
                            onClick={() => {
                              const url = item.documentURL as string
                              const pathName = new URL(url).pathname
                              
                              console.log(item.documentURL, 'item.documentURL',pathName,item.title)
                                // Use DocumentViewerModal for supported file types
                                setSelectedFile({
                                  url: item.documentURL as string,
                                  name: item.title
                                })
                                setShowDocumentViewer(true)
                              
                            }}
                          >
                            <img
                              alt={'eye-icon'}
                              src={toAbsoluteUrl('/media/icon/eye.svg')}
                              className='me-2'
                              style={{height: '18px', width: '18px'}}
                            />
                            <span>View</span>
                          </Button>
                        ) : (
                          <Button
                            onClick={() => {
                              setRequestedResource({id: item.id})
                              openRequestAccessModal()
                            }}
                          >
                            <img
                              alt={'lock-icon'}
                              src={toAbsoluteUrl('/media/icon/lock.svg')}
                              className='me-2'
                              style={{height: '18px', width: '18px'}}
                            />
                            <span>Request Access</span>
                          </Button>
                        )}
                      </div>
                    ))}
                  </div>
                </div>
              )
          )
        ) : (
          <div
            className='w-100 h-100 d-flex align-items-center justify-content-center'
            style={{border: '1px solid #D1D5DB', borderRadius: '8px', paddingBlock: '24px'}}
          >
            <span className='text-custom-primary-gray fw-medium' style={{fontSize: '16px'}}>
              {policiesDocuments.every((item) => item.list.length === 0)
                ? 'No resources added'
                : 'No matching resources found'}
            </span>
          </div>
        )}
      </div>
      
      {/* Document Viewer Modal */}
      <DocumentViewerModal
        show={showDocumentViewer}
        onClose={() => {
          setShowDocumentViewer(false)
          setSelectedFile(null)
        }}
        file={selectedFile}
      />
    </div>
  )
}

export default ResourcesTab
